import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Carousel } from '@vtex/butik/lib'

import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import {
  cleanImageUrl,
  changeImageUrlSize,
  areSkuMediasEquals,
} from '@/checkout-instore-legacy/utils/ProductUtils'

const changeImageUrlWidth = (url, width) =>
  changeImageUrlSize(cleanImageUrl(url), width, 'auto')

const thresholds = [640]
const imageSizes = [1280, 1920]
const thumbnailSize = 160

class ProductCarousel extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      !areSkuMediasEquals(nextProps.images, this.props.images) ||
      !areSkuMediasEquals(nextProps.videos, this.props.videos)
    )
  }

  getBestUrlIndex = (thresholds) => {
    const windowSize = window.innerWidth

    let bestUrlIndex = 0
    thresholds.forEach((threshold, i) => {
      if (windowSize > threshold) bestUrlIndex = i + 1
    })

    return bestUrlIndex
  }

  getApiKeyFromUrl(videoUrl) {
    return this.isYoutubeVideo(videoUrl)
      ? getInstoreConfig().youtubeApiKey
      : undefined
  }

  isYoutubeVideo(videoUrl) {
    return videoUrl.search('youtube') !== -1
  }

  getSlidesFromProps() {
    const { images, videos } = this.props

    const imageToSlide = (image) => ({
      type: 'image',
      urls: imageSizes.map((size) => changeImageUrlWidth(image, size)),
      alt: '',
      thumbUrl: changeImageUrlWidth(image, thumbnailSize),
      bestUrlIndex: this.getBestUrlIndex(thresholds),
    })

    const invalidVideos = (videoUrl) => {
      return !this.isYoutubeVideo(videoUrl) || this.getApiKeyFromUrl(videoUrl)
    }

    const videoToSlide = (videoUrl) => {
      const apiKey = this.getApiKeyFromUrl(videoUrl)
      return {
        type: 'video',
        src: videoUrl,
        apiKey,
      }
    }

    const imageSlides = images.map(imageToSlide)
    const videoSlides = videos.filter(invalidVideos).map(videoToSlide)

    return imageSlides.concat(videoSlides)
  }

  render() {
    return <Carousel slides={this.getSlidesFromProps()} />
  }
}

ProductCarousel.propTypes = {
  images: PropTypes.array,
  videos: PropTypes.array,
}

export default ProductCarousel
